import { lazy, Suspense, Fragment } from "react";
// import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Routes, Route } from "react-router-dom";
import Header from "./Components/Header";
import { Container } from "react-bootstrap";
import Footer from "./Components/Footer";
import "./Screens/HomeScreen.css";

const AboutUsScreen = lazy(() => import("./Screens/AboutUsScreen"));
const HomeScreen = lazy(() => import("./Screens/HomeScreen"));
const ContactUsScreen = lazy(() => import("./Screens/ContactUsScreen"));
const ProjectsScreen = lazy(() => import("./Screens/ProjectsScreen"));
const DTCPrivacyPolicy = lazy(() => import("./Screens/DTCPrivacyPolicy"));

function App() {
  return (
    <Fragment   >
      <>
      <Header />
      <main>
      <Container fluid style={{padding:'0'}} >
      <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path="/" element={<HomeScreen />}  />
        <Route path="/aboutus" element={<AboutUsScreen/>}/>
        <Route path="/projects" element={<ProjectsScreen />} />
        <Route path="/contact" element={<ContactUsScreen />} />
        <Route path="/dtcprivacy" element={<DTCPrivacyPolicy />} />
      </Routes>
      
      </Suspense>
      </Container>
      </main>
      <Footer/> 
      
      </>
    </Fragment>

  );
}

export default App;
